<template>
  <div class="container" ref="wrapper">
    <el-container>
      <el-header height="auto" ref="header">
        <search-bar
          v-model="formData"
          @search="handleSearch"
          @reset="handleReset"
          ref="search"
        ></search-bar>
      </el-header>
    </el-container>
    <div class="main">
      <div class="left">
        <div class="title">
          <strong style="width: 60%">搜索结果框</strong>
          <div style="text-align: right; width: 100%">
            <el-button type="primary" plain @click="combinationImg"
              >组合图片</el-button
            >
          </div>
        </div>
        <div class="checkAll">
          <el-checkbox v-model="checkAll" @change="handleCheckALl"
            ><strong>全选</strong></el-checkbox
          >
          <div style="position:absolute;right:9.6px;top:10px"><el-link :underline="false" type="danger" @click="remove(0,true)" v-if="bigModelList.length">全部移除</el-link></div>
        </div>
        <div class="checkbox" v-if="bigModelList.length">
          <el-checkbox-group v-model="print" @change="checkChange">
            <div
              v-for="(item,index) in bigModelList"
              :key="item.productCode"
              style="
                height: 60px;
                padding: 10px 0;
                border-bottom: 1px solid #e4e7ed;
                position: relative;
              "
            >
               <div
                style="
                  position: absolute;
                  right: 0;
                  top: 20px
                  font-size: 14px;
                  z-index: 100;
                "
              >
                <el-link :underline="false" type="danger" @click="remove(index)">移除</el-link>
              </div>
              <el-checkbox :label="item"
                ><strong>{{ item.productName}}</strong>
                <div
                  style="
                    height: 19.2px;
                    position: absolute;
                    top: 34.56px;
                    color: #606266;
                  "
                >
                  <span v-if="item.color">颜色：</span><span
                    style="display: inline-block; padding-right: 10px"
                    v-if="item.color"
                    >{{ item.color }}</span
                  >
                  <span v-if="item.price">日常活动到手价：</span><span
                    style="display: inline-block; padding-right: 10px"
                    v-if="item.price"
                    >{{ item.price }}</span
                  >
                  <span v-if="item.style">风格：</span><span
                    style="display: inline-block; padding-right: 10px"
                    v-if="item.style"
                    >{{ item.style }}</span
                  >
                </div>
              </el-checkbox>
            </div>
          </el-checkbox-group>
        </div>
      </div>
      <div class="right">
        <div class="title-right">
          <strong>分类销量排名</strong>
          <div>
            <el-button class="orange-btn" @click="batchSearch(1)">批量查看</el-button>
            <el-button type="danger" @click="batchSearch(2)">清除</el-button>
          </div>
        </div>
        <div class="tableAll" v-loading="loading" v-if="seachTableData.length"> 
          <div class="tbale-box" v-for="(item,index) in seachTableData" :key="index">
            <div> 
              <div class="tbale-header">
              <el-button>{{ tableData[index][0].categoryName }}</el-button>
            </div>
            <div class="serach">
              <div class="text">型号</div>
              <el-input
                placeholder="请输入型号信息搜索"
                v-model.trim="rightsearch['rightsearch'+index]"
                clearable
                class="cusSearch"
                @clear="clear('right')"
              >
              <i slot="prefix" class="el-input__icon el-icon-search"></i>
                <el-button slot="append" @click="searchRight(rightsearch['rightsearch'+index],index)">搜索</el-button>
              </el-input>
            </div>
            </div>
            <!-- <div style="height:70%"> -->
              <el-table
              :data="item"
              :header-cell-style="{
                backgroundColor: '#FAFAFA',
              }"
              :key="item.length"
              :row-style="{ height: '50px' }"
              :cell-style="rowClass"
              height="calc(100% - 120px)"
            >
              <el-table-column
                prop="rankingNum"
                align="center"
                label="排名"
                width="50px"
              ></el-table-column>
              <el-table-column
                prop="bigModel"
                align="center"
                width="90px"
                label="型号"
              ></el-table-column>
              <el-table-column
                prop="saleNum"
                align="center"
                width="80px"
                label="当前店铺"
              ></el-table-column>
              <el-table-column prop="price" width="120px" align="center" label="日常活动到手价">
              </el-table-column>
              <el-table-column prop="type" align="center" label="产品筛选">
                <template slot-scope="scope">
                  <el-link
                    :underline="false"
                    type="primary"
                    @click="showDialog(scope.row, item[0].categoryName)"
                    >查看</el-link
                  >
                </template>
              </el-table-column>
            </el-table>
            </div>
            
          <!-- </div> -->
        </div>
        <div class="no-data" v-else>暂无数据</div>
      </div>
    </div>
    <!-- 查看弹框 -->
    <property-view v-model="recordDialogVisible" @dialog="dialog" :dialogData="dialogData" @bigModelAdd="bigModelAdd" v-if="recordDialogVisible"></property-view>
    <combination-img v-model="combinationVisible" @combinationNone="combinationNone" :ombinationData="print" v-if="combinationVisible"></combination-img>
  </div>
</template>

<script>
import propertyView from "./propertyView.vue";
import combinationImg from "./combinationImg.vue";
import searchBar from "./search";
import pagePathMixin from '@/utils/page-path-mixin'
export default {
  name: "salesVolumeQuery",
  mixins: [pagePathMixin],
  components: {
    searchBar,
    propertyView,
    combinationImg
  },
  data() {
    return {
      tableHeight: 0,
      loading: false,
      loading2: false,
      formData: {},
      tableData: [],
      seachTableData: [],
      propListTwo: [],
      print: [],
      checkAll: false,
      propList: [],
      recordDialogVisible: false,
      combinationVisible: false,
      rightsearch:{
        rightsearch0:"",
        rightsearch1:"",
        rightsearch2:"",
        rightsearch3:"",
        rightsearch4:"",
        rightsearch5:"",
        rightsearch6:"",
        rightsearch7:"",
        rightsearch8:"",
        rightsearch9:"",
        rightsearch10:"",
        rightsearch11:"",
        rightsearch12:"",
        rightsearch13:"",
        rightsearch14:"",
      },
      bigModelList: [],
      dialogData: [],
      bigModeAddList: [],
      batchType: false
    };
  },
  computed: {
  },

  mounted() {
    // this.init()
    this.tableHeight =
      this.$refs["wrapper"].offsetHeight -
      this.$refs["search"].$el.offsetHeight -
      91;
  },
  methods: {
    handleCheckALl() {
      if (this.checkAll) {
        this.print = this.bigModelList;
      } else {
        this.print = [];
      }
    },
    checkChange(val) {
      if (val.length == this.bigModelList.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    combinationImg() {
      if (this.print.length > 4) {
        this.$message.error("已超过4个产品，请核对！");
        return;
      }else if(!this.print.length) {
        this.$message.error("请先选择产品，请核对！");
        return;
      }
      this.combinationVisible = true
    },
    remove(index,type)  {
      if(!type) {
        this.bigModelList.splice(index,1)
        this.bigModeAddList.splice(index,1)
        this.print.splice(index,1)
      }else {
        this.bigModelList = []
        this.bigModeAddList = []
        this.print = []
        this.checkAll =  false
      }
    },



    
    batchSearch(index) {
      console.log(this.tableData);
      if(index == 1) {
        let number = 0
        let value = ""
        let valueLength = []
        Object.keys(this.rightsearch).forEach((key,index)=>{
            console.log(this.rightsearch[key]);
            if(this.rightsearch[key]) {
              number += 1 
              value = this.rightsearch[key]
              valueLength.push(value)
            }
        })
        let valueType = valueLength.filter(v=>v!=value)
        if(number>1 && valueType.length) {
          this.$message.error('分类型号搜索存在两个不同型号，请核对！')
          return
        }else if(number == 0) {
          this.$message.error('请输入搜索型号！')
          return
        }
        Object.keys(this.rightsearch).forEach((key,index)=>{
            this.rightsearch[key] = value
            if(this.seachTableData[index]) {
              this.$set(this.seachTableData,index,this.tableData[index].filter((item) =>item.bigModel == value).slice(0,10))
            }
            
        })
      }else {
        Object.keys(this.rightsearch).forEach((key,index)=>{
            this.rightsearch[key] = ''
            if(this.seachTableData[index]) {
            this.$set(this.seachTableData,index,this.tableData[index].slice(0,10))
            }
        })
        console.log(this.tableData);
      }


    },
    bigModelAdd(data) {
      let next = this.bigModelList.map(v=>v.productCode)
      if(!next.includes(data.productCode)) {
        this.bigModeAddList.push(data)
      }
      this.bigModelList = [...new Set(this.bigModeAddList)]
      console.log(this.bigModeAddList);
      if (this.print.length == this.bigModelList.length) {
        this.checkAll = true;
      } else {
        this.checkAll = false;
      }
    },
    handleSearch(data) {
      this.rightsearch = {
        rightsearch0:"",
        rightsearch1:"",
        rightsearch2:"",
        rightsearch3:"",
        rightsearch4:"",
        rightsearch5:"",
        rightsearch6:"",
        rightsearch7:"",
        rightsearch8:"",
        rightsearch9:"",
        rightsearch10:"",
        rightsearch11:"",
        rightsearch12:"",
        rightsearch13:"",
        rightsearch14:"",
      },
      this.formData = data;
      this.print = []
      this.checkAll = false;
      this.init();
    },
    handleReset() {
      this.seachTableData = []
    },
    searchRight(prop,index) {
      if(prop!='') {
       this.$set(this.seachTableData,index,this.tableData[index].filter((item) =>item.bigModel == prop).slice(0,10))
      }else {
         this.$set(this.seachTableData,index,this.tableData[index].slice(0,10))
      }
    },
    init() {
      this.loading = true;
      this.formData = {
        // space: "卧室",
        // storeCode: "DY001"//"DY001"
        ...this.formData
      }
      this.$q.intelligentRecom
        .categoryTopTen({ data: this.formData })
        .then((res) => {
          if (res.data.length && res.code == 200) {
            this.tableData = res.data
            this.seachTableData = JSON.parse(JSON.stringify(this.tableData))
            this.seachTableData.forEach((v,index)=>{
              if(v.length>10) {
                this.$set(this.seachTableData,index,v.slice(0,10))
              }
            })
          } else {
            this.seachTableData = [];
          }
        }).catch(error => {
          this.seachTableData = [];
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    showDialog(row,categoryName) {
      this.see(row.bigModel,categoryName)
    },
    //产品基础属性查看 搜索
    see(bigModel,categoryName) {
      let data = {
        ...this.formData,
        bigModel: bigModel,
        categoryName: categoryName,
      }
      this.$q.intelligentRecom
        .bigModelBaseData({data})
        .then((res) => {
          if (res.data && res.code == 200) {
            this.dialogData = res.data;
            this.recordDialogVisible = true;
          } else {
            // this.tableData = [];
          }
        })
        .finally((_) => {
          this.loading = false;
        });
    },
    dialog(type) {
      this.recordDialogVisible = type;
    },
    combinationNone(type) {
      this.combinationVisible = type;
    },
    rowClass(data) {
      if (data.column.label == "当前店铺") {
        return "color: #4BBFE2;";
      } else if (data.column.label == "日常活动到手价") {
        return "color: #FF8A02;";
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.container {
  margin: 5px 5px 10px 5px;
  width: auto;
  height: calc(100% - 15px);
  box-sizing: border-box;
  border-radius: 5px;
}

>>> .el-header {
  background: #ffffff;
  padding: 0 8px;
  margin-bottom: 5px;
  position: relative;
  border-radius: 5px;
}

.main {
  height: calc(100% - 50px);
  display: flex;
  flex-wrap: nowrap;
}

.left {
  width: 360px;
  border-radius: 5px;
  background: #ffffff;
}

.right {
  height: 100%;
  width: calc(100% - 360px);
  margin-left: 5px;
  background: #ffffff;
  border-radius: 5px;
}

.title {
  font-size: 16px;
  color: #444;
  padding: 20px 9.6px 20px 9.6px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
}

.title-right {
  font-size: 16px;
  color: #444;
  padding: 20px 18px 20px 18px;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between;
}

>>> .title-right .el-button {
  font-size: 12px;
  height: 26px
}

.checkAll {
  position: relative
  padding: 0px 9.6px 5px 9.6px;
}

>>> .checkAll .el-checkbox__label {
  padding: 9.6px 19.2px 0 19.2px;
  font-size: 14px;
}

.checkbox {
  height: calc(100% - 120px);
  width: 100%;
  color: #606266;
  overflow-x: hidden;
}

>>> .checkbox .el-checkbox {
  display: flex;
  justify-items: top;
}

>>> .checkbox .el-checkbox__label {
  padding: 9.6px 19.2px 0 19.2px;
  font-size: 14px;
}

// >>> .checkbox .el-checkbox__inner {
// margin-left: 19.2px;
// }
>>> .checkbox .el-checkbox__input {
  padding-top: 12.48px;
}

>>> .checkbox .el-checkbox-group {
  border: none !important;
  padding: 0px 9.6px;
}

>>> .checkbox::-webkit-scrollbar {
  
  width: 5px;
  height: 5px;
}

>>> .tbale-box::-webkit-scrollbar {
  
  width: 5px;
  height: 5px;
}

>>> .el-table th {
  background: #fff !important;
}

.tableAll {
  padding: 10px 20px;
  height: calc(100% - 100px);
  display:flex;
  flex-warp:nowarp;
  overflow-y:hidden
}

.tbale-box {
  height: calc(100% - 40px);
  padding: 10px;
  max-width: 410px;
  border: 1px #e4e7ed solid;
  border-radius: 8px;
}

.tbale-box:not(:first-child){
	height: calc(100% - 40px);
  padding: 10px;
  max-width: 410px;
  margin-left: 10px
  border: 1px #e4e7ed solid;
  border-radius: 8px;
}

.tbale-box /deep/.el-table {
  border: 0;

  th, tr, td {
    border: 0;
    background-color: #fff;
  }

  &::before {
    height: 0px;
  }

  &::after {
    width: 0;
  }

  .el-table__fixed:before {
    height: 0;
  }
}

.tbale-header {
  width: 100%;
  padding: 10px 0;
}

>>> .tbale-header .el-button {
  width: 100%;
  padding: 10px
  background: #f6f8fa;
  color: #000
}

>>> .cusSearch .el-input__suffix {
  display: flex !important;
  align-items: center !important;
}

>>> .cusSearch .el-input__inner {
  background: #f6f8fa !important;
  font-size: 12px;
  height: 30px;
}

>>> .cusSearch .el-input-group__append .el-button {
  position: relative;
  top: -1.5px;
  font-size: 12px;
  background: #0bb78e;
  color: #ffffff;
  height: 30px;
  border-radius: 0px 4px 4px 0px;
}

>>> .el-input-group {
  width: calc(100% - 80px)
}

.serach{
  padding: 10px 0
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: space-between
  
}

.text {
  width: 80px
  display: flex;
  align-items: center
  justify-content: center
}


.no-data {
  width: 100%;
  height: calc(100% - 100px)
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999999;
}
</style>